module.exports = __webpack_public_path__ + "57ea442b93e3b3fe4d2ffd922155193b.png";